export const SET_MESSAGE = (state, message) => {
    state.message = message;
  };
  
  